import { render, staticRenderFns } from "./SelectListaComponent.vue?vue&type=template&id=4c53d029"
import script from "./SelectListaComponent.vue?vue&type=script&lang=js"
export * from "./SelectListaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports